<!-- Custom banner component using design system conventions -->
<lib-ui-alpha-feature-enabler>
  <ng-container phase="ai">
    @if (aiMessagesCount() > 0) {
      <div
        class="flex items-center w-full gap-[1rem] py-2 pl-[12px] pr-[1rem] banner">
        <!-- Sparkles icon with blue-600 color -->
        <img src="assets/sparkles-blue.svg" alt="Sparkles" />
        <!-- Message content -->
        @for (message of aiMessages(); track message) {
          <div class="b1 text-gray-1000" [innerHTML]="message.detail"></div>
        }
      </div>
    }
  </ng-container>
  <ng-container phase="ga">
    @if (messagesCount()) {
      <m-messages [messages]="messages()" [escape]="false"></m-messages>
    }
  </ng-container>
</lib-ui-alpha-feature-enabler>
